import { useCreateBalanceAdjustment } from 'api-hooks/transactions/balance-adjustment';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import BalanceAdjustmentForm from './components/form';

export type BalanceAdjustmentsCreateParams = null;

export default function BalanceAdjustmentsCreate(
  props: NavigationProps<NavigationRoutes.BalanceAdjustmentsCreate>,
) {
  const { mutateAsync, error } = useCreateBalanceAdjustment();

  const onResolve = useApprovalableEdit('balance-adjustments');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <BalanceAdjustmentForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
